<div class="footer">
  <div class="footer-background-gradient"></div>
  <div class="footer-background-particles"></div>
  <div
    class="footer-card-container align-items-end lg:align-items-center justify-content-center flex overflow-hidden text-center lg:text-justify"
  >
    <div class="footer-card flex-grow-1 flex px-4 py-5 lg:px-8 lg:py-7">
      <div class="footer-card-body">
        <div
          class="top align-items-center lg:align-items-start flex-column flex lg:flex-row"
        >
          <div class="logo lg:w-22rem align-items-center lg:align-items-start">
            <img
              class="hidden lg:block"
              src="assets/svg/footer/biocron_logo_primary_dark_horizontal.svg"
              alt="Logo Biocron"
            />
            <img
              class="h-4rem block lg:hidden"
              src="assets/svg/footer/biocron_logo_primary_dark_vertical.svg"
              alt="Logo Biocron"
            />
            <p class="text secondary-font">
              {{ footerContent.description }}
            </p>
          </div>
          <div class="menu primary-font hidden lg:flex">
            <a class="link" routerLink="/nosotros">{{
              footerContent.routes.aboutUs
            }}</a>
            <a class="link" routerLink="/servicios">{{
              footerContent.routes.services
            }}</a>
            <a class="link" routerLink="/industrias">{{
              footerContent.routes.industries
            }}</a>
            <a class="link" routerLink="/blog">{{
              footerContent.routes.blog
            }}</a>
            <a class="link" routerLink="/contacto">{{
              footerContent.routes.contact
            }}</a>
          </div>
        </div>
        <div
          class="bottom align-items-center lg:align-items-end flex-column-reverse flex gap-5 lg:flex-row lg:gap-0"
        >
          <div
            class="bottom-vertical secondary-font align-items-center lg:align-items-start"
          >
            <div class="down-left">
              <div
                class="legal flex-column align-items-center lg:align-items-start secondary-font flex gap-2 text-center lg:flex-row lg:gap-5"
              >
                <a>{{ footerContent.documents.termsOfUse }}</a>
                <a>{{ footerContent.documents.privacyPolicy }}</a>
                <a>{{ footerContent.documents.dataTreatmentPolicy }}</a>
              </div>
              <div>
                <p class="copyright secondary-font">
                  {{ footerContent.copyright }}
                </p>
              </div>
            </div>
          </div>
          <div class="social primary-font">
            <p class="contact-us primary-font">
              {{ footerContent.socialsTitle }}
            </p>
            <div class="social-buttons">
              <a class="social-button">
                <img src="/assets/svg/biocron_instagram_icon.svg" />
              </a>
              <a
                class="social-button"
                [href]="footerContent.socials.linkedin"
                target="_blank"
              >
                <img src="/assets/svg/biocron_linkedin_icon.svg" />
              </a>
              <a
                class="social-button"
                [href]="'mailto:' + footerContent.socials.email"
                target="_blank"
              >
                <img src="/assets/svg/biocron_email_icon.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
